import React from "react";
import { Box, Typography, Stack, Button } from "@mui/material";

const portfolioTabs = [
  { id: "all", label: "All Portfolios" },
  { id: "gioo-plots", label: "Gio Nano Plots" },
  { id: "residential", label: "Residential Plots" },
  { id: "flats-villas", label: "Flats & Villas" },
  { id: "syndicate-plots", label: "Syndicate Plots" },
  { id: "material-store", label: "Material Store" },
];

export default function CategorySelector({ value, onChange }) {
  const currentTab = value || "all";

  return (
    <Box sx={{ width: "100%", mb: 2 }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gap={1.5}
      >
        {/* Left: Portfolio Pill Tabs */}
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap gap={1}>
          {portfolioTabs.map((tab) => {
            const isActive = currentTab === tab.id;
            return (
              <Button
                key={tab.id}
                onClick={() => onChange && onChange(tab.id)}
                sx={{
                  bgcolor: isActive ? "#163F1D" : "#EAF4EC",
                  color: isActive ? "#FFFFFF" : "#163F1D",
                  borderRadius: "50px",
                  px: 2.2,
                  py: 0.8,
                  fontSize: "0.82rem",
                  fontWeight: 700,
                  textTransform: "none",
                  boxShadow: "none",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    bgcolor: isActive ? "#0F2F14" : "#DDF0E1",
                  },
                }}
              >
                {tab.label}
              </Button>
            );
          })}
        </Stack>

        {/* Right: Live Allocations Indicator */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              bgcolor: "#59B400",
              boxShadow: "0 0 8px #59B400",
            }}
          />
          <Typography
            sx={{
              fontSize: "0.75rem",
              fontWeight: 800,
              color: "#1E5C2D",
              letterSpacing: "0.5px",
              textTransform: "uppercase",
            }}
          >
            28 REAL-TIME ALLOCATIONS LIVE
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
}